import FeedbackList from './FeedbackList';

export default FeedbackList;
